import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class ProductApplicationIdUnknownException extends QuoteException {

}